<template>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else>
    <b-col cols="12">
      <hr class="mt-1 mb-2">
      <span class="h6">{{$t("views.agreements.form.items")}}: </span>
    </b-col>
    <b-col>
      <table v-if="data.packageItems && data.packageItems.length > 0" class="table table-responsive-md table-sm table-hover not-border-table">
        <thead class="text-center">
        <tr>
          <th style="width: 8%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
          </th>
          <th style="width: 15%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
          </th>
          <th style="width: 15%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatAmount')}}</p>
          </th>
          <th style="width: 20%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
          </th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in data.packageItems" :key="index">
        <tr>
          <td><span class="h6"> {{ index + 1 }} </span></td>
          <!--    TOWAR-->
          <td>
            <model-select v-if="data.packageItems.length > 0"
                          v-model="data.packageItems[index].item"
                          :options="itemOptions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="item"
                          v-on:input="updatePricesInItem(index)">
            </model-select>
          </td>
          <!--    WARTOŚĆ NETTO-->
          <td class="pt-0 pb-0">
            <input v-on:change="calculatePriceBrutto(index)" type="number" v-model="item.priceNetto" class="form-control">
          </td>
          <!--    STAWKA VAT-->
          <td>
            <input type="text" disabled="true" :value="getVatRate(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ VAT-->
          <td>
            <input type="number" disabled="true" :value="item.vatValue" class="form-control">
          </td>
          <!--    WARTOŚĆ BRUTTO-->
          <td>
            <input type="number" disabled="true" v-model="item.priceBrutto" class="form-control">
          </td>
          <td>
            <button type="button" class="btn btn-danger" @click="removePosition(index)">{{ $t('buttons.delete') }}</button>
          </td>
        </tr>
        </tbody>
      </table>
      <b-row>
        <b-col>
          <b-button class="btn btn-primary" @click="addNewPosition()">{{ $t('views.exsbinvoices.form.addNewInvoicePosition') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import Loader from '@/components/Dashboard/Layout/Loader'
import remove from '@/utils/remove'

export default {
  name: 'PackageItems',
  data () {
    return {
      isLoading: false
    }
  },

  props: ['data', 'violations'],

  components: {
    ModelSelect,
    Loader
  },

  computed: {
    ...mapGetters({
      itemOptions: 'packages/list/getWarehouseItems',
      getItemById: 'packages/list/getWarehouseItemById'
    }),
    isUpdateRoute () {
      return this.$route.name === 'EXABPackagesUpdate'
    }
  },

  created () {
    this.fetchWarehouseItems()
  },

  methods: {
    ...mapActions({
      fetchWarehouseItems: 'packages/list/fetchWarehouseItemsOptions'
    }),
    removePosition (index) {
      let currentPosition = this.data.packageItems[index]
      if (currentPosition['@id']) {
        remove(currentPosition['@id'], () => {
          this.data.packageItems.splice(index, 1)
        })
      } else {
        this.data.packageItems.splice(index, 1)
      }
    },
    addNewPosition () {
      this.data.packageItems.push({
        item: '',
        priceNetto: '0',
        purchasePriceNetto: '0',
        priceBrutto: '0',
        vatValue: '0'
      })
    },
    updatePricesInItem (index) {
      this.data.packageItems[index].priceNetto = this.getPriceNetto(index)
      this.data.packageItems[index].priceBrutto = this.getPriceBrutto(index)
      this.data.packageItems[index].vatValue = Math.round((this.data.packageItems[index].priceBrutto - this.data.packageItems[index].priceNetto) * 100) / 100
    },
    getPriceNetto (index) {
      return Math.round((this.getPriceBrutto(index) - this.getVatValue(index)) * 100) / 100
    },
    getPriceBrutto (index) {
      if (!this.getCurrentItem(index).item) return 0
      return this.getItemById(this.getCurrentItem(index).item).priceBrutto
    },
    getVatRate (index) {
      if (!this.getCurrentItem(index).item) return 0
      return this.getItemById(this.getCurrentItem(index).item).vatRate.value
    },
    getVatValue (index) {
      if (!this.getCurrentItem(index).item) return 0
      return Math.round(this.calculateVatValue(index) * 100) / 100
    },
    calculateVatValue (index) {
      return (this.getPriceBrutto(index) * this.getVatRate(index)) / (100 + this.getVatRate(index))
    },
    calculatePriceBrutto (index) {
      let priceNetto = this.data.packageItems[index].priceNetto
      let priceBrutto = Math.round((priceNetto * (1 + (this.getVatRate(index) / 100))) * 100) / 100
      this.data.packageItems[index].priceBrutto = priceBrutto
      this.data.packageItems[index].vatValue = Math.round((this.data.packageItems[index].priceBrutto - this.data.packageItems[index].priceNetto) * 100) / 100
    },
    getCurrentItem (index) {
      if (!this.data.packageItems[index]) return null
      return this.data.packageItems[index]
    }
  }
}
</script>
